import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
// @mui
import { useTheme } from '@mui/material/styles'
import { Box } from '@mui/material'

// ----------------------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
}

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme()
	const PRIMARY_MAIN = theme.palette.primary.main

	const logo = (
		<Box sx={{ width: 100, height: 70, ...sx }}>
			{/* <img src="/statics/logo_text.png" /> */}
			<img alt='logo' src={theme.palette.mode === 'dark' ? '/statics/logo_white.png' : "/statics/logo.png"} />
		</Box>
	)

	if (disabledLink) {
		return <>{logo}</>
	}

	return <RouterLink to="/">{logo}</RouterLink>
}
